import React, { useState } from 'react';
import { UploadIcon, FileIcon, XIcon } from 'lucide-react';
interface ArtworkUploadProps {
  onFileSelect?: (file: File | null) => void;
}
export function ArtworkUpload({
  onFileSelect
}: ArtworkUploadProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const handleFileSelect = (file: File | null) => {
    setSelectedFile(file);
    onFileSelect?.(file);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) handleFileSelect(file);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    handleFileSelect(file);
  };
  const clearFile = () => {
    handleFileSelect(null);
  };
  if (selectedFile) {
    return <div className="border border-border rounded-sm p-3 bg-surface" data-id="element-292">
        <div className="flex items-center justify-between" data-id="element-293">
          <div className="flex items-center gap-2" data-id="element-294">
            <FileIcon className="w-4 h-4 text-text-secondary" data-id="element-295" />
            <span className="text-sm text-text-primary truncate max-w-[200px]" data-id="element-296">
              {selectedFile.name}
            </span>
            <span className="text-xs text-text-tertiary" data-id="element-297">
              ({(selectedFile.size / 1024 / 1024).toFixed(1)} MB)
            </span>
          </div>
          <button onClick={clearFile} className="p-1 text-text-tertiary hover:text-text-primary transition-colors" aria-label="Remove file" data-id="element-298">
            <XIcon className="w-4 h-4" data-id="element-299" />
          </button>
        </div>
      </div>;
  }
  return <label onDragOver={e => {
    e.preventDefault();
    setIsDragging(true);
  }} onDragLeave={() => setIsDragging(false)} onDrop={handleDrop} className={`
        block border-2 border-dashed rounded-sm p-6
        cursor-pointer transition-colors duration-150
        ${isDragging ? 'border-primary bg-surface-warm' : 'border-border hover:border-text-tertiary'}
      `} data-id="element-300">
      <input type="file" accept=".png,.jpg,.jpeg,.pdf" onChange={handleInputChange} className="sr-only" data-id="element-301" />
      <div className="flex flex-col items-center text-center" data-id="element-302">
        <UploadIcon className="w-8 h-8 text-text-tertiary mb-2" data-id="element-303" />
        <span className="text-sm font-medium text-text-primary" data-id="element-304">
          Upload Artwork
        </span>
        <span className="text-xs text-text-tertiary mt-1" data-id="element-305">
          PNG, JPG, PDF up to 10MB
        </span>
      </div>
    </label>;
}